// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d056a7ff","239":"61dd2d2a","488":"a24a9e0f","667":"582b8920"}[chunkId] + ".chunk.js";
};